export enum ClientTypesPermissions {
  VIEW_CLIENT_TYPES = "view_client_types",
  CREATE_CLIENT_TYPES = "create_client_types",
  UPDATE_CLIENT_TYPES = "update_client_types",
  DELETE_CLIENT_TYPES = "delete_client_types",
  ARCHIVE_CLIENT_TYPES = "archive_client_types",
}

export const ClientTypesPermissionsText: Record<
  ClientTypesPermissions,
  string
> = {
  [ClientTypesPermissions.VIEW_CLIENT_TYPES]: "View Client Types",
  [ClientTypesPermissions.CREATE_CLIENT_TYPES]: "Create Client Types",
  [ClientTypesPermissions.UPDATE_CLIENT_TYPES]: "Update Client Types",
  [ClientTypesPermissions.DELETE_CLIENT_TYPES]: "Delete Client Types",
  [ClientTypesPermissions.ARCHIVE_CLIENT_TYPES]: "Archive Client Types",
};
